@if (src) {
  <img
    class="upload-element"
    [ngSrc]="src" [height]="height" [width]="width" (error)="getPresignedUrl()">
}
